import { Axios } from "index";
export const otherGoodsItemSrnoDropdownApi =
  "/other-goods-inventory/item-srno-dropdown";
export const otherGoodsInwardSrnoDropdownApi =
  "/other-goods-inventory/inward-srno-dropdown";

//Approval
export const fetchOtherGoodsApprovalApi = `/approval/otherGoods-approval-invoice-listing`;
export const fetchOtherGoodsItemsApprovalApi = function (id, invoice_id) {
  return `/approval/othergoods-approval-item-listing-by-invoice/${id}/${invoice_id}`;
};
export const othergoodsApproveInvoiceApi = function (id, invoice_id) {
  return `/approval/othergoods-approve_invoice_details/${id}/${invoice_id}`;
};
export const othergoodsRejectInvoiceApi = function (id, invoice_id) {
  return `/approval/othergoods-reject_invoice_details/${id}/${invoice_id}`;
};

export const fetchOtherGoodsInwardNo = async (id) => {
  const res = await Axios.get(
    `/other-goods-inventory/inward-sr-no-dropdown/${id}`
  );
  return res;
};
export const fetchOtherGoodsNoDropdown = async (id, itemId) => {
  const res = await Axios.get(
    `/other-goods-inventory/item-sr-no-dropdown/${id}/${itemId}`
  );
  return res;
};
export const fetchOtherGoodsNoById = async (id) => {
  const res = await Axios.get(`/other-goods-inventory/list-details/${id}`);
  return res;
};

export const addRawOrderOtherGoods = async (data) => {
  const res = await Axios.post(
    "/order/issue-raw-other-goods-order/issue-order",
    data
  );
  return res;
};
export const revertRawOrderOtherGoods = async (id) => {
  const res = await Axios.post(`/order/revert-order/${id}`);
  return res;
};
